package com.xtream.data_kmp.dto

 import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.KSerializer
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Serializer
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonDecoder
import kotlinx.serialization.json.JsonObject


@Serializable
class InfoExt(
    @Serializable(UnwrappingJsonListSerializer::class)
    override val backdrop_path: List<String>?=null,
    override val cast: String?=null,
    override val director: String?=null,

    override val duration: String?=null,
    override val duration_secs: Int?=null,
    override val genre: String?=null,
    override val movie_image: String?=null,
    override val plot: String?=null,
    override val rating: String?=null,

    @SerialName("releasedate")
    override val releaseDate: String?=null,
    override val tmdb_id: String?=null,
    @kotlinx.serialization.Transient
    override val bitrate: Int?=null,
    override val year: String?=null,
    override val mpaa: String?=null,
    @SerialName("youtube_trailer")
    override val youtubeTrailer: String?=null,
    override val name: String?=null

): InfoBase(){
    @kotlinx.serialization.Transient
    override val audio: Audio?=null
    @kotlinx.serialization.Transient
    override val video: Video?=null
}

@OptIn(ExperimentalSerializationApi::class)
@Serializer(forClass =  InfoBase::class)
object InfoSerializer : KSerializer<InfoBase> {
    override fun deserialize(decoder: Decoder): InfoBase {
        val json = (decoder as JsonDecoder).decodeJsonElement()



        return parseInfo(json)
    }

    private fun parseInfo(json: Any?): InfoBase {


        return when (json) {
            is JsonArray -> InfoExt()
            is JsonObject ->{
                //Log.d("parseInfo",json.toString())
                val normalizedJson = JsonObject(json.mapKeys { (key, _) ->
                    when (key) {
                        "releaseDate" -> "releasedate"  // normalize to "releaseDate"
                        else -> key
                    }
                })
                //  Info()
                val js= Json{
                    ignoreUnknownKeys=true
                    explicitNulls=false

                }
                js.decodeFromJsonElement<InfoExt>(InfoExt.serializer(),normalizedJson)
            }
            else -> InfoExt()
        }
        /* return try {
            Json.decodeFromString<Info>(info.toString())
         } catch (e: Exception) {
             //(info as JsonArray).map { Json.decodeFromString<Name>(it.toString()) }
             Info()
         }*/
    }
}